import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { listAlbums } from './api'
import getSearchContext from './getSearchContext'

class VideoSelectorBrowse extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      albums: [],
      browseSection: '',
    }

    this.getSearchContext = getSearchContext.bind(this)

    this.onBrowseClick = this.onBrowseClick.bind(this)
    this.toggleBrowseSection = this.toggleBrowseSection.bind(this)
    this.renderAlbums = this.renderAlbums.bind(this)
  }

  componentDidMount() {
    this.cancelRemainingRequests = false
    this.makeCancellableRequest(listAlbums, (data) =>
      this.setState({ albums: data.albums })
    )
    const { setSearchContext } = this.props
    setSearchContext(this.getSearchContext('all:video'))
  }

  componentWillUnmount() {
    this.cancelRemainingRequests = true
  }

  onBrowseClick(e, key, object) {
    e.preventDefault()
    const newContext = this.getSearchContext(key, object)
    const { setSearchContext } = this.props
    setSearchContext(newContext)
  }

  makeCancellableRequest(apiFunc, data, callback) {
    apiFunc(data, (...args) => {
      if (!this.cancelRemainingRequests) {
        callback(...args)
      }
    })
  }

  toggleBrowseSection(section) {
    const { browseSection } = this.state
    if (browseSection !== section) {
      this.setState({ browseSection: section })
    } else {
      this.setState({ browseSection: '' })
    }
  }

  renderAlbums() {
    const { albums, browseSection } = this.state
    const { context } = this.props
    if (albums.length > 0) {
      let expandedClass = ''
      if (browseSection === 'albums') {
        expandedClass = 'browse-section-expanded'
      }
      return (
        <div
          className={`browse-section browse-section-expandable ${expandedClass}`}
        >
          <h3>
            <div
              onClick={() => {
                this.toggleBrowseSection('albums')
              }}
            >
              <FormattedMessage defaultMessage="Categories" />
              <span>{albums.length}</span>
            </div>
          </h3>
          <ul>
            {albums.map((album) => {
              const key = `album:${album.album_id}`
              return (
                <li
                  key={album.album_id}
                  className={context.key === key ? 'active' : ''}
                >
                  <a
                    href="/"
                    onClick={(e) => {
                      this.onBrowseClick(e, key, album)
                    }}
                  >
                    {album.title}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      )
    }
    return null
  }

  render() {
    const { searchIn, context } = this.props

    const searchInPhotos = searchIn.indexOf('photos') > -1
    const searchInLive = searchIn.indexOf('live') > -1
    const searchInAlbums = searchIn.indexOf('albums') > -1
    const searchInSite = searchIn.indexOf('site') > -1

    return (
      <div className="browse-container">
        <div className="browse-section">
          <ul>
            {(searchInPhotos || searchInSite) && (
              <li className={context.key === 'all:video' ? 'active' : ''}>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <a
                  href="/"
                  onClick={(e) => {
                    this.onBrowseClick(e, 'all:video')
                  }}
                >
                  <FormattedMessage defaultMessage="All videos" />
                </a>
              </li>
            )}
            {(searchInLive || searchInSite) && (
              <li className={context.key === 'all:live' ? 'active' : ''}>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <a
                  href="/"
                  onClick={(e) => {
                    this.onBrowseClick(e, 'all:live')
                  }}
                >
                  <FormattedMessage defaultMessage="All live events" />
                </a>
              </li>
            )}
            {searchInPhotos && (
              <li
                className={context.key === 'all:video:recent' ? 'active' : ''}
              >
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <a
                  href="/"
                  onClick={(e) => {
                    this.onBrowseClick(e, 'all:video:recent')
                  }}
                >
                  <FormattedMessage defaultMessage="Most recent" />
                </a>
              </li>
            )}
            {searchInPhotos && (
              <li className={context.key === 'all:video:views' ? 'active' : ''}>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <a
                  href="/"
                  onClick={(e) => {
                    this.onBrowseClick(e, 'all:video:views')
                  }}
                >
                  <FormattedMessage defaultMessage="Most viewed" />
                </a>
              </li>
            )}
          </ul>
        </div>
        {searchInPhotos || searchInAlbums ? this.renderAlbums() : null}
      </div>
    )
  }
}

VideoSelectorBrowse.propTypes = {
  context: PropTypes.object,
  setSearchContext: PropTypes.func.isRequired,
  searchIn: PropTypes.arrayOf(
    PropTypes.oneOf(['photos', 'albums', 'live', 'site'])
  ).isRequired,
}

export default VideoSelectorBrowse
